/**
 * 绑定辅助工具
 *
 * 处理配置属性的黑板绑定
 */
export class BindingHelper {
    /**
     * 获取配置值（考虑黑板绑定）
     *
     * @param context 执行上下文
     * @param configKey 配置键名
     * @param defaultValue 默认值
     * @returns 解析后的值
     */
    static getValue(context, configKey, defaultValue) {
        const { nodeData, runtime } = context;
        if (nodeData.bindings && nodeData.bindings[configKey]) {
            const blackboardKey = nodeData.bindings[configKey];
            const boundValue = runtime.getBlackboardValue(blackboardKey);
            return boundValue !== undefined ? boundValue : defaultValue;
        }
        const configValue = nodeData.config[configKey];
        return configValue !== undefined ? configValue : defaultValue;
    }
    /**
     * 检查配置是否绑定到黑板变量
     */
    static hasBinding(context, configKey) {
        return !!(context.nodeData.bindings && context.nodeData.bindings[configKey]);
    }
    /**
     * 获取绑定的黑板变量名
     */
    static getBindingKey(context, configKey) {
        return context.nodeData.bindings?.[configKey];
    }
}
/**
 * 节点执行器注册表
 *
 * 管理所有节点类型的执行器
 */
export class NodeExecutorRegistry {
    constructor() {
        this.executors = new Map();
    }
    /**
     * 注册执行器
     *
     * @param implementationType 节点实现类型（对应BehaviorNodeData.implementationType）
     * @param executor 执行器实例
     */
    register(implementationType, executor) {
        if (this.executors.has(implementationType)) {
            console.warn(`执行器已存在，将被覆盖: ${implementationType}`);
        }
        this.executors.set(implementationType, executor);
    }
    /**
     * 获取执行器
     */
    get(implementationType) {
        return this.executors.get(implementationType);
    }
    /**
     * 检查是否有执行器
     */
    has(implementationType) {
        return this.executors.has(implementationType);
    }
    /**
     * 注销执行器
     */
    unregister(implementationType) {
        return this.executors.delete(implementationType);
    }
    /**
     * 清空所有执行器
     */
    clear() {
        this.executors.clear();
    }
}
//# sourceMappingURL=NodeExecutor.js.map